<template>
  <div>

    <div class="d-flex justify-content-between align-items-center d-flex-grap mb-2">
      <h4>Campos personalizados</h4>
      <b-button id="show-btn" @click="onHandleOpenModalToCreateNewCustomField()" variant="primary">
        <i class="fa fa-plus mr-1"></i> Agregar</b-button>
    </div>

    <el-tree :data="customFields.itemInTree" :show-checkbox="false" node-key="id" highlight-current
      :filter-node-method="filterNode" draggable :default-expand-all="true" :expand-on-click-node="true">
      <div class="custom-tree-node d-flex justify-content-between align-items-center" slot-scope="{ node }">
        <span :class="`${node.data.is_active ? 'text-black' : 'text-danger'}`">
          {{ node.data.label }}
        </span>

        <div class="d-flex justify-content-center align-items-center ml-4">
          <el-tooltip content="Editar" placement="bottom" effect="light">
            <el-button type="text" size="medium" class="text-primary" @click="onHandleOpenToEditItem(node.data)">
              <i class="fa fa-edit" />
            </el-button>
          </el-tooltip>
          <el-tooltip class="ml-2" :content="node.data.is_active ? 'INACTIVAR' : 'ACTIVAR'" placement="bottom"
            effect="light">
            <el-button v-if="node.data.children.length === 0 || !node.data.is_active" type="text" size="medium"
              :class="`${!node.data.is_active ? 'text-success' : 'text-danger'}`"
              @click="onHandleOpenToDeleteItem(node.data)">
              <i :class="`fa ${node.data.is_active ? 'fa-close' : 'fa-check'}`" />
            </el-button>
          </el-tooltip>
        </div>
      </div>
    </el-tree>

  </div>
</template>

<script>

// Importaciones generales
import { mapState, mapActions, mapMutations } from "vuex";

// Componentes
import Swal from 'sweetalert2';

export default {
  name: "CustomFieldsListComponent",
  data() {
    return {
      value: null,
      selecionadosIds: [],
      defaultProps: {
        disabled: "disabled",
      },
    };
  },
  computed: {
    // Estados para el modulo del Naciones unidas - gre
    ...mapState('NuGreCustomFields', [
      'customFields'
    ]),
  },
  methods: {
    // Mutaciones para el modulo de Naciones unidas - gre
    ...mapMutations('NuGreCustomFields', [
      'setCustomField',
      'setAction',
      'resetCustomField'
    ]),
    // Acciones para el modulo del Naciones unidas - gre
    ...mapActions('NuGreCustomFields', [
      'update'
    ]),
    filterNode(value, data) {
      if (!value) return true;
      return data.label.toLowerCase().indexOf(value.toLowerCase()) !== -1;
    },
    /**
     * Abrir los detalles del ítem actual para su edición.
     * @author Fernando Claros
     */
    onHandleOpenToEditItem(item) {
      this.setAction('EDIT')

      this.setCustomField({
        id: item.id,
        title: item.label,
        slq_custom_field_nu_gre_id: item.slq_custom_field_nu_gre_id
      })

      this.$bvModal.show('bv-modal-manage-custom-fields')
    },
    /**
     * Abrir los detalles del ítem actual para su eliminación.
     * @author Fernando Claros
     */
    onHandleOpenModalToCreateNewCustomField() {
      this.setAction('CREATE')
      this.resetCustomField();
      this.$bvModal.show('bv-modal-manage-custom-fields')
    },
    /**
     * Abrir los detalles del ítem actual para su eliminación.
     * @author Fernando Claros
     */
    onHandleOpenToDeleteItem(item) {

      const payload = {
        id: item.id,
        title: item.label,
        slq_custom_field_nu_gre_id: item.slq_custom_field_nu_gre_id || null,
        is_active: !item.is_active
      };

      const action = item.is_active ? 'inactivar' : 'activar'

      Swal.fire({
        icon: "warning",
        title: "Campos personalizados",
        text: `¿Está seguro que desea ${action} el ítem ${item.label}?.`,
        showConfirmButton: true,
        showCancelButton: true,
        confirmButtonText: `Si, ${action}!`,
        cancelButtonText: 'Cancelar'
      }).then(async (result) => {
        if (result.isConfirmed) await this.update(payload);
      });

    }
  }
};
</script>

<style scoped>
.content {
  max-width: 100%;
  overflow-x: auto;
}
</style>
